import { backgroundColors, TextColors } from "../constants/colors";

export function getRandomBackgroundColor(){
    return backgroundColors[Math.floor(Math.random() * backgroundColors.length)]
}
export function getRandomTextColor(){
    return TextColors[Math.floor(Math.random() * TextColors.length)]
}